module.exports = __webpack_public_path__ + "fonts/quicksand-latin-300-normal.7c326aa.woff";